<template>
  <div>
    <DDMainpic :skuImg="mainPic?.fieldContent" />
    <div class="main-body">
      <template v-for="(item, index) in productInfolist" :key="index">
        <div v-if="item.moduleName != '商品主图'">
          <div class="quality-box" v-if="item.fieldType == configType.table">
            <TraceLine :baseInfo="item"></TraceLine>
          </div>
          <div class="quality-box" v-else>
            <div v-if="item.detailVOS[0]?.fieldType == configType.context">
              <BaseInfo :configType="configType" :baseInfo="item"></BaseInfo>
            </div>
            <div v-if="item.detailVOS[0]?.fieldType == configType.pic">
              <TracePic :baseInfo="item"></TracePic>
            </div>
          </div>
          <div
            v-if="
              item.moduleCode == productModuleCode &&
                !traceInfo.isSingleMaterial
            "
          >
            <material-info :materialInfoList="materialInfoList"></material-info>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BaseInfo from "./components/BaseInfo.vue";
import TraceLine from "./components/TraceLine.vue";
import TracePic from "./components/TracePic.vue";
import { configType } from "./components/config";
import DDMainpic from "@/components/Mainpic.vue";
import MaterialInfo from "./components/Material-Info.vue";

export default {
  data() {
    return {
      productInfolist: [],
      materialInfoList: [],
      mainPic: {},
      configType,
      productModuleCode: ""
    };
  },
  components: {
    BaseInfo,
    DDMainpic,
    TracePic,
    TraceLine,
    MaterialInfo
  },
  props: {
    traceInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.productInfolist = this.traceInfo.productInfo?.templateInfoList;
    this.mainPic = this.productInfolist[0]?.detailVOS[0];
    this.materialInfoList = this.traceInfo.materialInfoList;
    this.productModuleCode = this.traceInfo.nodeModuleCode;
    for (let i = 0; i < this.productInfolist.length; i++) {
      if (
        this.productInfolist[i].detailVOS[0] &&
        this.productInfolist[i].detailVOS[0].fieldType == configType.table
      ) {
        this.productInfolist[i].fieldType = configType.table;
      } else {
        this.productInfolist[i].detailVOS.forEach(detailItem => {
          if (detailItem.fieldType == configType.pic) {
            detailItem.qualityImage = [
              {
                describe: detailItem.fieldName,
                imageHost: "",
                uploadUrl: detailItem.fieldContent
              }
            ];
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.quality-box {
  background: white;
  margin-bottom: 0px !important;
  padding: 15px !important;
}

.main-body {
  padding: 0px !important;
}
</style>
